import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export default function Consent() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const x1 = useTransform(scrollYProgress, [0, 1], ["8%", "-8%"]);
  const x2 = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  return (
    <section ref={ref} data-testid="consent-section" className="relative py-32 sm:py-48 overflow-hidden">
      <p className="text-center font-tt-mono text-[12px] uppercase tracking-[0.35em] text-[#D9B47A] mb-14 px-5">
        Consent, Sacred Safety & Conscious Connection
      </p>
      <motion.p style={{ x: x1 }} className="font-display text-[clamp(2.4rem,7.5vw,8rem)] leading-[1] whitespace-nowrap text-center">
        May you know the holiness of your <em className="text-[#C2414F]">no.</em>
      </motion.p>
      <motion.p style={{ x: x2 }} className="font-display text-[clamp(2.4rem,7.5vw,8rem)] leading-[1] whitespace-nowrap text-center mt-4">
        May you know the radiance of your <em className="text-[#D9B47A]">yes.</em>
      </motion.p>
    </section>
  );
}
